import {
    Component,
    OnInit,
    ChangeDetectorRef,
    PLATFORM_ID,
    Inject,
    Optional,
    inject,
    DestroyRef,
    signal,
    input,
    ViewChild,
    ElementRef,
    DOCUMENT
} from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { FavoritesService } from '../../services/favorites.service';
import { ParamFilters } from '../../models/filtermodels/ParamFilters';
import { Item } from '../../models/hotels/Item';
import { OfferpackService } from '../../services/offerpack.service';
import { AuthGuardService } from '../../services/auth-guard.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AuthService } from '../../services/auth.service';
import { GlobalmenuService } from '../../services/globalmenu.service';
import { Customer } from '../../models/customers/Customer';
import { Price } from '../../models/hotels/Price';
import { Partner } from '../../models/partner/IPartner';
import { CruiseSearchParams } from '@app/models/filtermodels/CruiseSearchParams';
import { EncryptionService } from '@app/services/encyption.service';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ChatService } from '@app/services/chat.service';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { PartnerloginComponent } from '../modals/partnerlogin/partnerlogin.component';
import { Menu } from './Menu';
import { GoToFilter } from '../tools/GoToFilter';
import { MEDIA_TOKEN } from 'tockens';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
export interface PathHistory {
    country: Item;
    region: Item;
    hotel: Item;
    flug: string;
    booking: Price;
}
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
    readonly defaultMenu = input<any>(undefined);
    desktopTemplate: boolean = true;
    mobile: boolean = false;
    realparams: ParamFilters | CruiseSearchParams | any;
    isOpen: boolean = false;
    openSubmenu: boolean = false;
    showsearch: boolean = false;
    partner: Partner;
    curentMenu;
    currentPage: string;
    partnername: string = '';
    sktvnumber: string = '';
    avatar: string;
    infiniteScrollFn: any;
    bckText: string;
    menuopen: boolean = false;
    menuloading = signal<boolean>(true);
    ticking: boolean = false;
    isactivemenu: string = '';
    isBrowser: boolean = false;
    favoritesCount: number = 0;
    offerpackCount: number = 0;

    pathHistory: PathHistory;
    currentCustomer: Customer;
    currentCountryCode: any;

    cruiseActive: boolean = false;
    ferienhauserActive: boolean = false;
    camperActive: boolean = false;
    showTvInput: boolean = false;
    showChat: boolean = false;
    showTermin: boolean = false;
    showTel: boolean = false;
    showhReisekompass: boolean = false;
    showhLogin: boolean = false;
    showhDigbrater: boolean = false;
    fixsetoultip: boolean = false;

    destroyRef = inject(DestroyRef);

    logo: string = '';
    tooltiptext: string = '';
    ops: string = '';

    @ViewChild('htmlcontainer', { static: false })
    set htmlcontainerRef(value: ElementRef | undefined) {
        this.htmlcontainer = value;
        if (value) {
            this.scheduleInitHtml();
        }
    }

    private htmlcontainer?: ElementRef;

    constructor(
        protected router: Router,
        protected route: ActivatedRoute,
        protected guardService: AuthGuardService,
        protected cdr: ChangeDetectorRef,
        protected authService: AuthService,
        protected dialog: MatDialog,
        protected chatService: ChatService,
        protected hotelFilterService: HotelFiltersService,
        protected favoritesService: FavoritesService,
        protected offerpackService: OfferpackService,
        protected mediaObserver: BreakpointObserver,
        protected globalmenuService: GlobalmenuService,
        protected encservice: EncryptionService,
        protected mymenu: Menu,
        @Inject(DOCUMENT) private document: any,
        @Inject(PLATFORM_ID) protected platformId: any,
        @Optional() @Inject(MEDIA_TOKEN) private media_token: string
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.desktopTemplate = this.media_token !== 'xs';
        this.mobile = this.media_token === 'xs';
    }

    ngOnInit(): void {
        this.initMedia();
        this.initFavoriten();
        this.initOfferpack();
        this.initPartner();
    }

    async initPartner() {
        this.guardService.getPartner$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((obj) => {
            if (obj?.partnerid?.length > 0) {
                this.partner = obj;
                this.showChat = !this.partner.hideChat;
                this.showTermin = !this.partner.hideTermin;
                this.showTel = !this.partner.hideTel;
                this.showhReisekompass = !this.partner.hideReisekompass;
                this.showhLogin = !this.partner.hideLogin;
                this.showhDigbrater = !this.partner.hideDigbrater;
                if (this.partner?.logo?.length > 0) {
                    this.logo = 'https://suntour-reisen.de/logo/' + this.partner.partnerid + '/' + this.partner.logo;
                } else {
                    if (isPlatformServer(this.platformId)) {
                        this.logo = 'https://suntour-reisen.de/assets/images/Suntour.reisen_2022_2.svg';
                    } else {
                        this.logo = '/assets/images/Suntour.reisen_2022_2.svg';
                    }
                }

                if (obj?.firstname?.length > 0) {
                    this.partnername = obj.firstname + ' ' + obj.lastname;
                }
                for (let i = 0; i < this.partner?.agenturen?.length; i++) {
                    if (this.partner?.agenturen[i]?.aktiv) {
                        this.ops += this.partner?.agenturen[i]?.code + ',';
                    }
                }
                this.checkCruise();
                this.checkCamper();
                this.checkFerienhauser();
                this.getDefaultmenu();
                this.initData();
            } else {
                this.partner = null;
                this.partnername = '';
            }
        });
    }

    openInput(): void {
        this.showTvInput = true;
    }

    async gotoCalendar() {
        this.router.navigate([this.guardService.getPartnerId(), 'terminkalender']);
    }

    openChat() {
        this.chatService.setOpenChat();
    }

    closeTvMenu(): void {
        this.showTvInput = false;
    }

    async initFavoriten() {
        this.favoritesService.favorites$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((count: number) => {
            this.favoritesCount = count;
            this.cdr.detectChanges();
        });
    }

    async initOfferpack() {
        this.offerpackService.offerpack$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((count: number) => {
            this.offerpackCount = count;
            this.cdr.detectChanges();
        });
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.desktopTemplate = true;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate = true;
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate = true;
        }
        this.cdr.detectChanges();
    }

    async checkCruise() {
        this.cruiseActive = this.partner?.xt?.active && this.partner?.xt?.ref?.length > 0;
    }

    async checkCamper() {
        this.camperActive = this.partner?.fti?.camper?.active && this.partner?.fti?.camper?.benum?.length > 0;
    }

    async checkFerienhauser() {
        this.ferienhauserActive = this.partner.partnerid === 'main' || this.partner.partnerid === 'reisen' || (this.partner?.atraveo?.active && this.partner?.atraveo?.ref?.length > 0);
    }

    async getDefaultmenu() {
        const defaultMenu = this.defaultMenu();
        // console.log(this.mymenu?.menu2)
        if (defaultMenu) {
            defaultMenu.title = 'Menü';
            this.mymenu.setMenus2(defaultMenu);
            this.mymenu.isDefault2.set(true);
            this.menuloading.set(false);
            this.scheduleInitHtml();
            this.cdr.detectChanges();
        }

        const target = {
            partnerid: this.partner.partnerid
        }
        this.globalmenuService.requestnew(target, 'getdefaultmenu').pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((res) => {
            if (res?.isDefault) {
                res.title = 'Menü';
                this.mymenu.setMenus2(res);
                this.mymenu.isDefault2.set(true);
                this.menuloading.set(false);
                this.scheduleInitHtml();
                this.cdr.detectChanges();
            } else {
                this.getglobalmenus();
            }
        });
    }

    private scheduleInitHtml() {
        if (!this.mymenu?.menu2?.asHtml) {
            return;
        }

        this.initHtml();
    }

    private createHtmlFragment(content: string) {
        const range = typeof this.document?.createRange === 'function' ? this.document.createRange() : null;

        if (typeof range?.createContextualFragment === 'function') {
            return range.createContextualFragment(content);
        }

        const template = this.document.createElement('template');
        template.innerHTML = content;

        if (template.content) {
            return template.content;
        }

        const fragment = this.document.createDocumentFragment();
        const wrapper = this.document.createElement('div');
        wrapper.innerHTML = content;

        while (wrapper.firstChild) {
            fragment.appendChild(wrapper.firstChild);
        }

        return fragment;
    }

    // async getglobalmenus() {
    //     const target = {
    //         partnerid: this.partner.partnerid
    //     }
    //     this.globalmenuService.request(target, 'getglobalmenus').pipe(
    //         takeUntilDestroyed(this.destroyRef)
    //     ).subscribe((res) => {
    //         // console.log(res)
    //         if (res?.active) {
    //             this.mymenu.setMenus(res);
    //         }
    //         this.menuloading.set(false);
    //         this.cdr.detectChanges();
    //     });
    // }

    async initHtml() {
        // console.log(this.htmlcontainer)
        if (this.htmlcontainer?.nativeElement) {
            const fragment = this.createHtmlFragment(this.mymenu.menu2.htmlcontent || '');
            const scripts: HTMLScriptElement[] = [];

            // collect + remove in one pass
            fragment.querySelectorAll?.('script').forEach(script => {
                scripts.push(script);
                script.remove();
            });

            // insert HTML
            this.htmlcontainer.nativeElement.textContent = '';
            this.htmlcontainer.nativeElement.appendChild(fragment);

            if (!this.isBrowser) {
                this.cdr.detectChanges();
                return;
            }

            // run scripts
            scripts.forEach(script => {
                const s = this.document.createElement('script');

                Array.from(script.attributes).forEach(attr => {
                    s.setAttribute(attr.name, attr.value);
                });

                if (script.src || script.getAttribute('src')) {
                    this.document.body.appendChild(s);
                    return;
                }

                s.textContent = script.textContent;
                this.document.body.appendChild(s);
                this.document.body.removeChild(s);
            });
        }
    }

    async getglobalmenus() {
        const target = {
            partnerid: this.partner.partnerid
        }
        this.globalmenuService.request(target, 'getglobalmenus').pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((res) => {
            // console.log(res)
            if (res?.active) {
                this.mymenu.setMenus(res);
            }
            this.menuloading.set(false);
            this.cdr.detectChanges();
        });
    }

    async openMenu(ev) {
        ev && ev.stopPropagation();
        document.body.style.overflow = 'hidden';
        this.curentMenu = [];
        this.openSubmenu = false;
        this.menuopen = true;
    }

    async closeMenu(ev) {
        ev.stopPropagation();
        document.body.style.overflow = '';
        this.menuopen = false;
    }

    async gobackMenu(ev) {
        ev.stopPropagation();
        this.mymenu.goBack();
    }

    async opensubmenu(ev) {
        this.mymenu.setCurrentMenu(ev);
    }

    async openLink(data) {
        new GoToFilter(this.encservice, this.router, this.guardService).goto(data, null);
        this.menuopen = false;
    }

    async goto(link) {
        this.isOpen = false;
        const url = this.router.createUrlTree([this.partner.partnerid, link]).toString();
        this.router.navigateByUrl(url);
    }

    async gotoCustomeraccount() {
        this.isOpen = false;
        const url = this.router.createUrlTree([this.partner.partnerid, 'customeraccount']).toString();
        this.router.navigateByUrl(url);
    }

    async initData() {
        this.authService.auth$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((customer: Customer) => {
            this.currentCustomer = customer;
            this.cdr.detectChanges();
        });
        this.pathHistory = {} as PathHistory;
    }

    async gotoContent() {
        const url = this.router.createUrlTree([this.partner.partnerid, 'contents']).toString();
        this.router.navigateByUrl(url);
    }

    async gotoAnfrage() {
        const url = this.router.createUrlTree([this.partner.partnerid, 'anfrage']).toString();
        this.router.navigateByUrl(url);
    }

    async gotofavorites() {
        const url = this.router.createUrlTree([this.partner.partnerid, 'favorites']).toString();
        this.router.navigateByUrl(url);
    }

    async gotoOfferpack() {
        const url = this.router.createUrlTree([this.partner.partnerid, 'offerpack']).toString();
        this.router.navigateByUrl(url);
    }

    async gotohome() {
        this.isactivemenu = '';
        const url = this.router.createUrlTree([this.partner.partnerid]).toString();
        this.router.navigateByUrl(url);
    }

    async gotoback() {
        const url = this.router.createUrlTree([this.partner.partnerid]).toString();
        this.router.navigateByUrl(url);
    }

    async gotokreuzfahrten() {
        const url = this.router.createUrlTree([this.partner.partnerid, 'kreuzfahrten']).toString();
        this.router.navigateByUrl(url);
    }

    async gotoferienwohnung() {
        const url = this.router.createUrlTree([this.partner.partnerid, 'ferienwohnung']).toString();
        this.router.navigateByUrl(url);
    }

    async logout() {
        // my account
        this.authService.logout(this.partner?.partnerid).pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(() => {
            this.offerpackService.resetOfferpackList();
            this.authService.resetCustomer(this.partner?.partnerid);
            const url = this.router.createUrlTree([this.partner.partnerid]).toString();
            this.router.navigateByUrl(url);
        });
    }

    gotosuntour(): void {
        const link = document.createElement('a');
        link.href = 'https://suntour-reisen.de';
        link.setAttribute('visibility', 'hidden');
        link.click();
    }

    async gotSktv() {
        if (this.sktvnumber?.length > 0) {
            const navigationExtras: NavigationExtras = {
                queryParams: { params: this.encservice.encrypt({ extra: { orderId: this.sktvnumber } }) }
            };
            const url = this.router.createUrlTree([(this.partner.partnerid === 'main' ? 'reisen' : this.partner.partnerid), 'sktv'], navigationExtras).toString();
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('visibility', 'hidden');
            link.click();
        }
    }

    async gotoPath(path1, path2?) {
        this.isactivemenu = path2?.length > 0 ? path2 : path1;
        this.hotelFilterService.setonlyDefault();
        const url = this.router.createUrlTree([(this.partner.partnerid === 'main' ? 'reisen' : this.partner.partnerid), path1]).toString();
        this.router.navigateByUrl(url);
    }

    async gotoFerienhauser() {
        this.isactivemenu = 'ferienhauser';
        this.hotelFilterService.setonlyDefault();
        if (this.partner.partnerid === 'main' || this.partner.partnerid === 'reisen') {
            const url = this.router.createUrlTree([(this.partner.partnerid === 'main' ? 'reisen' : this.partner.partnerid), 'ferienhauser']).toString();
            this.router.navigateByUrl(url);
        } else if (this.ferienhauserActive) {
            const url = this.router.createUrlTree([(this.partner.partnerid === 'main' ? 'reisen' : this.partner.partnerid), 'ferienwohnung']).toString();
            this.router.navigateByUrl(url);
        }
    }

    async gotoPartner() {
        let target = {} as MatDialogConfig;
        this.currentCustomer = {} as Customer;
        this.currentCustomer.partnerid = this.guardService.getPartnerId();
        if (this.desktopTemplate) {
            target = {
                width: '400px',
                panelClass: 'customModal',
                maxHeight: '100vh',
                disableClose: true,
                data: {
                    partnerdomain: this.partner.partnerdomain,
                    password: this.currentCustomer.password,
                    partnerid: this.currentCustomer.partnerid,
                    email: this.currentCustomer.email,
                    modeLogin: true
                }
            };
        } else {
            target = {
                width: '100%',
                height: '100vh',
                maxWidth: '100%',
                panelClass: 'customModal',
                disableClose: true,
                data: {
                    partnerdomain: this.partner.partnerdomain,
                    password: this.currentCustomer.password,
                    partnerid: this.currentCustomer.partnerid,
                    email: this.currentCustomer.email,
                    modeLogin: true
                }
            };
        }
        const diagRef = this.dialog.open(PartnerloginComponent, target);
        diagRef.afterClosed().pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(result => {
            if (result?.token?.length > 0) {
                this.currentCustomer = result;
                this.authService.setAuth(this.currentCustomer);
            }
        });
    }
}
